import api from "./api";

// Settings → API tokens (backend: ApiTokenController). The token itself comes back once, from create.
const tokenService = {
	listOwn: async () => (await api.get("/tokens")).data,
	listAll: async () => (await api.get("/admin/tokens")).data,
	create: async (name, expiresInDays) => (await api.post("/tokens", { name, expiresInDays })).data,
	revoke: async (id) => {
		await api.delete(`/tokens/${id}`);
	},
};

export default tokenService;
